import { putComma } from "@/lib/utils";
import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell, LabelList } from "recharts";

function OverallCard({ data, selectedDuration }) {
    const [chartData, setChartData] = useState([]);

    const processData = (n = 0) => {
        return [
            { name: "Promoters", value: data[n]?.promoters || 0 },
            { name: "FII", value: data[n]?.foreignInstitutions || 0 },
            {
                name: "DII",
                value: data[n]?.domesticInstitutions || 0
            },
            { name: "Public", value: data[n]?.others + data[n]?.retail || 0 }
        ];
    };

    useEffect(() => {
        setChartData(processData(data?.findIndex((element) => element.quarter === selectedDuration)));
    }, [selectedDuration]);

    return (
        <div className="w-full font-Inter font-medium">
            <ResponsiveContainer width="100%" height={228}>
                <BarChart
                    data={chartData}
                    layout="vertical"
                    barCategoryGap={16}
                    margin={{ top: 20, right: 66, left: -44, bottom: 0 }}
                >
                    <XAxis hide type="number" className="font-Inter font-semibold text-xs" />
                    <YAxis type="category" dataKey="name" tick={false} axisLine={false} tickLine={false} />
                    <Bar
                        dataKey="value"
                        radius={[4, 4, 4, 4]} // Rounded corners for the bars
                        background={{ fill: "#eee", radius: 4 }}
                    >
                        {chartData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill="#0862BC" />
                        ))}
                        <LabelList
                            dataKey="name"
                            position="insideTop"
                            content={({ x, y, height, value }) => (
                                <text
                                    x={x + 1}
                                    y={y - 10}
                                    fill="black"
                                    fontSize={12}
                                    fontFamily="'Inter', 'sans-serif'"
                                    fontWeight={600}
                                    textAnchor="start"
                                    dominantBaseline="middle"
                                >
                                    {value}
                                </text>
                            )}
                        />
                        <LabelList
                            dataKey="value"
                            position="top"
                            fill="#202020"
                            formatter={(value) => putComma(value)}
                            offset={8}
                            className="font-Inter font-semibold text-xs"
                            content={({ x, y, width, value, viewBox }) => (
                                <text
                                    x={document.getElementById("overall-card").offsetWidth - 12}
                                    y={y + 10}
                                    fill="black"
                                    fontSize={12}
                                    fontFamily="'Inter', 'sans-serif'"
                                    fontWeight={600}
                                    textAnchor="end"
                                    dominantBaseline="middle"
                                >
                                    {putComma(value)}%
                                </text>
                            )}
                        />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}

export default OverallCard;
